import loadable from '@loadable/component';
import { toPercentage } from '@/utilities/formatting';
import ReportSection from '@/components/ReportSection';
import ReportSubSection from '@/components/ReportSubSection';
import ReportSectionHeader from '@/components/ReportSectionHeader';
import {
  PORTFOLIO_STATIC_COMPANY,
  PORTFOLIO_DEBT_LEVEL,
} from '@/constants/feedbackSections';
import DeferRenderUntilIntersecting from '@/components/DeferRenderUntilIntersecting';

const NoData = loadable(() => import('@/components/NoData'), {
  resolveComponent: (component) => component.NoData,
});
const ChartActionsContainer = loadable(
  () => import('@/components/ChartActions'),
  {
    ssr: false,
    resolveComponent: (component) => component.ChartActionsContainer,
  }
);
const DebtLevelChart = loadable(() => import('../DebtLevelChart'), {
  ssr: false,
  resolveComponent: (component) => component.DebtLevelChart,
});

export interface HealthProps {
  sectionNumber: number;
  debtEquity?: number;
  portfolioId: string;
  lastUpdated: number;
}

const Health = ({
  sectionNumber,
  debtEquity,
  portfolioId,
  lastUpdated,
}: HealthProps) => (
  <ReportSection sectionNumber={sectionNumber}>
    <ReportSectionHeader
      title="Financial Health"
      sectionDescription="The average Portfolio debt to equity ratio ignoring financial institutions"
      keyMetricTitle={debtEquity ? 'Portfolio Debt to Equity' : ''}
      keyMetric={debtEquity ? toPercentage(debtEquity, 2) : undefined}
    />
    <ReportSubSection
      title="Portfolio Debt Level"
      trackingProps={{ subject: 'chart' }}
      body={
        debtEquity ? (
          <DeferRenderUntilIntersecting preRenderHeight={400}>
            {() => (
              <>
                <DebtLevelChart
                  debtEquity={debtEquity}
                  portfolioId={portfolioId}
                  lastUpdated={lastUpdated}
                />
                <ChartActionsContainer
                  companyName={PORTFOLIO_STATIC_COMPANY}
                  feedbackLabel={PORTFOLIO_DEBT_LEVEL}
                />
              </>
            )}
          </DeferRenderUntilIntersecting>
        ) : (
          <NoData />
        )
      }
    />
  </ReportSection>
);

export default Health;
